import { useCallback, useMemo } from 'react';
import { useTranslations } from '@/i18n/translations';
import { INDUSTRY_CODES, type IndustryCode } from '@leanin/shared';

export type IndustryOption = { readonly value: IndustryCode; readonly label: string };

// Stable per locale so memoized consumers don't recompute on every render.
export function useIndustryLabel(): (code: IndustryCode) => string {
  const tm = useTranslations('Members');
  return useCallback((code: IndustryCode) => tm(`industries.${code}`), [tm]);
}

export function useIndustryOptions(): ReadonlyArray<IndustryOption> {
  const label = useIndustryLabel();
  return useMemo(() => INDUSTRY_CODES.map((value) => ({ value, label: label(value) })), [label]);
}
